import "./polyfills";
import "./index.css";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import {initRum} from "./app/rum";
import {App} from "./App";

initRum();

const root = createRoot(document.getElementById("root")!);
root.render(
    <BrowserRouter future={{v7_relativeSplatPath: true, v7_startTransition: true}}>
        <App/>
    </BrowserRouter>
);
